export default "__VITE_ASSET__LkScHITE__"